// Copyright (c) StrangeBee 2024

import { Route as SearchHomeRoute } from './List';
export const Routes = [SearchHomeRoute];
